// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.101.3/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.101.3/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Company theme styles */
.company-theme {
  --company-primary: inherit;
  --company-secondary: inherit;
  --company-font: inherit;
}

/* Dynamic company colors will be applied through inline styles */
/* But we can define some common styles */
.company-theme h1,
.company-theme h2,
.company-theme h3 {
  color: var(--company-primary);
}

.company-theme a {
  color: var(--company-secondary, var(--company-primary));
}

.company-theme .company-accent {
  background-color: var(--company-primary);
  color: white;
}

.company-theme .company-accent-secondary {
  background-color: var(--company-secondary, var(--company-primary));
  color: white;
}

/* Company font styles */
.company-theme[data-font] {
  font-family: var(--company-font), system-ui, -apple-system, sans-serif;
} `, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
